import { bindRequestLogic } from './utils'
import PersIOTMessageTypes from '../actionTypes/persIOTMessage'
import { persIOTMessageAPI } from '../api'

const getPersIOTMessages = bindRequestLogic({
  clientFunc: persIOTMessageAPI.getPersIOTMessages,
  type: PersIOTMessageTypes.GET_PERS_IOT_MESSAGE_REQUEST,
  successType: PersIOTMessageTypes.GET_PERS_IOT_MESSAGE_SUCCESS,
  failType: PersIOTMessageTypes.GET_PERS_IOT_MESSAGE_FAILED,
  isQueryParam: true
})

export default [getPersIOTMessages]
